import { Button, ButtonProps, styled } from "@mui/material";
import { BaseButtonPropType } from "../../types/app.type";

export const BaseButton = styled(Button)<ButtonProps & BaseButtonPropType>(({ variant, fontSize, fontWeight, radius, padding, bgcolor, border, colour }) => {
    return {
        fontFamily: "Inter",
        fontWeight: fontWeight || 700,
        fontSize: fontSize || 24,
        lineHeight: "normal",
        borderRadius: radius || "5px",
        border: (variant === "contained") ? "none" : border || "1px solid #CCCCCC",
        color: (variant === "contained") ? "#FFFFFF" : colour || "#871585",
        background: variant === "contained" ? (bgcolor || "linear-gradient(to right, #791377 16%, #A91BA6 53%, #DF23DB 100%)") : (bgcolor || "transparent"),
        padding: padding || "calc(var(--basic-padding)/2) calc(var(--basic-padding))",
        textTransform: "capitalize",
        minWidth: 0,
        "&:hover": {
            border: (variant === "contained") ? "none" : border || "1px solid #CCCCCC",
            background: (variant === "contained") ? (bgcolor || "linear-gradient(to right, #791377 16%, #A91BA6 53%, #DF23DB 100%)") : (bgcolor || "transparent"),
        }
    }
})